//

import { axiosRequest } from '@/util/axios-request';

// 规则-获得tab
export var getTab = function getTab(data) {
  return axiosRequest({
    url: '/web/payroll_rule/get_tab',
    method: 'get',
    params: data
  });
};

// 考勤规则-获得设置
export var getAttendance = function getAttendance(data) {
  return axiosRequest({
    url: '/web/payroll_rule/get_attendance',
    method: 'get',
    params: data
  });
};
export var saveAttendance = function saveAttendance(data) {
  return axiosRequest({
    url: '/web/payroll_rule/save_attendance',
    data: data
  });
};

// 工资设置
export var getSalary = function getSalary(data) {
  return axiosRequest({
    url: '/web/payroll_rule/get_salary',
    method: 'get',
    params: data
  });
};
export var saveSalary = function saveSalary(data) {
  return axiosRequest({
    url: '/web/payroll_rule/save_salary',
    data: data
  });
};

// 获取 税
export var getTax = function getTax(params) {
  return axiosRequest({
    url: '/web/payroll_rule/get_tax',
    method: 'get',
    params: params
  });
};

// 保存 税
export var saveTax = function saveTax(data) {
  return axiosRequest({
    url: '/web/payroll_rule/save_tax',
    data: data
  });
};

// 获取 社保
export var getSocialSecurity = function getSocialSecurity(params) {
  return axiosRequest({
    url: '/web/payroll_rule/get_social_security',
    method: 'get',
    params: params
  });
};

// 保存 税
export var saveSocialSecurity = function saveSocialSecurity(data) {
  return axiosRequest({
    url: '/web/payroll_rule/save_social_security',
    data: data
  });
};

// 导入项添加
export var createitemimport = function createitemimport(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/createitemimport',
    data: data
  });
};

// 编辑项添加
export var updateItemImport = function updateItemImport(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/updateItemImport',
    data: data
  });
};

// 删除提示
export var isDeleteToast = function isDeleteToast(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/isDeleteToast',
    data: data
  });
};

// 编辑项添加
export var deleteItemImport = function deleteItemImport(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/deleteItem',
    data: data
  });
};